import { bookingThemeStyle, deriveBookingTheme } from '@shared/core/booking-branding'
import classNames from 'classnames'
import { CalendarDays } from 'lucide-react'
import type { CSSProperties } from 'react'
import { useIntl } from 'react-intl'
import { Typography } from 'src/modules/core/components'
import type { BrandingPreviewProps } from './branding-preview.interface'
import classes from './branding-preview.module.scss'

const SAMPLE_SLOTS = ['9:00 AM', '9:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM']
const SELECTED_SLOT = '10:00 AM'

export function BrandingPreview({ accent, logoSrc, providerName, bookingPageUrl }: BrandingPreviewProps) {
  const { formatMessage } = useIntl()
  const themeStyle = bookingThemeStyle(deriveBookingTheme(accent)) as CSSProperties | undefined

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography variant="body" className={classes.title}>
          {formatMessage({ id: 'settings.bookingBranding.preview.title' })}
        </Typography>
        <a href={bookingPageUrl} target="_blank" rel="noopener noreferrer" className={classes.liveLink}>
          {formatMessage({ id: 'settings.bookingBranding.preview.openLivePage' })}
        </a>
      </div>
      <div className={classes.page} style={themeStyle} data-testid="booking-branding-preview" aria-hidden>
        <div className={classes.card}>
          {logoSrc ? (
            <img className={classes.logo} src={logoSrc} alt="" data-testid="booking-branding-preview-logo" />
          ) : (
            <div className={classes.iconTile}>
              <CalendarDays />
            </div>
          )}
          <span className={classes.pageTitle}>
            {formatMessage({ id: 'settings.bookingBranding.preview.bookWith' }, { name: providerName })}
          </span>
          <span className={classes.link}>{formatMessage({ id: 'settings.bookingBranding.preview.timezoneLink' })}</span>
          <div className={classes.slots}>
            {SAMPLE_SLOTS.map((slot) => (
              <span key={slot} className={classNames(classes.slot, { [classes.slotSelected]: slot === SELECTED_SLOT })}>
                {slot}
              </span>
            ))}
          </div>
          <span className={classes.button}>{formatMessage({ id: 'settings.bookingBranding.preview.continue' })}</span>
        </div>
      </div>
      <Typography variant="body" className={classes.caption}>
        {formatMessage({ id: 'settings.bookingBranding.preview.caption' })}
      </Typography>
    </div>
  )
}
